import React from 'react';
import { motion } from 'framer-motion';
const MILESTONES = [{
  label: 'Hito 01',
  title: 'OLT',
  subtitle: 'Ordenamiento Local del Territorio',
  href: '#resultados',
  image: 'https://cdn.magicpatterns.com/uploads/b3XxDpPc3kRjBQ4H7ZEj2X/paramo.jpg'
}, {
  label: 'Hito 02',
  title: 'Escuelas Interculturales',
  subtitle: 'Educación intercultural en territorio',
  href: '#hito-2',
  image: 'https://cdn.magicpatterns.com/uploads/uvomHhxcF8NJnuNLw2V2RY/IMG_9119.jpg'
}, {
  label: 'Hito 03',
  title: 'Acuerdos con PNN',
  subtitle: 'Acuerdos con Parques Nacionales Naturales',
  href: '#hito-3',
  image: 'https://cdn.magicpatterns.com/uploads/4kU1SJA6DC7TJSuGJguKjo/paramillo.jpg'
}, {
  label: 'Hito 04',
  title: 'Usabilidad IGAC',
  subtitle: 'Apropiación de los productos del IGAC',
  href: '#hito-4',
  image: 'https://cdn.magicpatterns.com/uploads/dGg8r9XUtvqygxxiqrPQif/mapacol.jpg'
}, {
  label: 'Formación',
  title: 'Diplomados virtuales',
  subtitle: 'Cursos en línea para la apropiación del conocimiento territorial',
  href: '#diplomados',
  image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&q=80'
}];
export function MilestonesStrip() {
  return <section id="hitos" className="relative z-30 -mt-24 md:-mt-32 px-4 md:px-8 max-w-[1400px] mx-auto" data-id="element-236">
      <div className="flex overflow-x-auto md:grid md:grid-cols-5 gap-4 md:gap-6 pb-8 snap-x snap-mandatory hide-scrollbar" data-id="element-237">
        {MILESTONES.map((milestone, index) => <motion.a key={milestone.title} href={milestone.href} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="group relative block flex-none w-[280px] md:w-auto h-[320px] md:h-[400px] snap-center overflow-hidden bg-forest cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-238">
            <div className="absolute inset-0 bg-forest/40 group-hover:bg-forest/20 transition-colors duration-500 z-10" data-id="element-239" />
            <img src={milestone.image} alt={milestone.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-240" />
            <div className="absolute inset-0 z-20 p-6 flex flex-col justify-end bg-gradient-to-t from-forest/90 via-forest/40 to-transparent" data-id="element-241">
              <span className="text-clay font-bold tracking-widest text-xs uppercase mb-2 block" data-id="element-242">
                {milestone.label}
              </span>
              <h3 className="text-bone font-serif text-xl md:text-2xl leading-tight mb-2" data-id="element-243">
                {milestone.title}
              </h3>
              <p className="text-bone/80 text-sm font-light leading-snug opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300" data-id="element-244">
                {milestone.subtitle}
              </p>
            </div>
          </motion.a>)}
      </div>
    </section>;
}